module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Salutation":"Anrede","First name":"Vorname","Last name":"Nachname","Email":"E-Mail","Change password":"Passwort ändern","Password":"Passwort","Phone":"Telefon","Company":"Firma","Mr.":"Herr","Mrs.":"Frau","Undefined":"Unbekannt"}}')
  delete Component.options._Ctor
}
